import { DistributorItemDto } from '../../api/dto/DistributorItemDto';
import { DistributorDto } from '../../api/dto/DistributorDto';

export class ProductTemplate {

    private headers: string[] =  [
        "Handle",
        "Title",
        "Body (HTML)",
        "Vendor",
        "Product Category",
        "Type",
        "Tags",
        "Published",
        "Option1 Name",
        "Option1 Value",
        "Option2 Name",
        "Option2 Value",
        "Option3 Name",
        "Option3 Value",
        "Variant SKU",
        "Variant Grams",
        "Variant Inventory Tracker",
        "Variant Inventory Qty",
        "Variant Inventory Policy",
        "Variant Fulfillment Service",
        "Variant Price",
        "Variant Compare At Price",
        "Variant Requires Shipping",
        "Variant Taxable",
        "Variant Barcode",
        "Image Src",
        "Image Position",
        "Image Alt Text	Gift Card",
        "SEO Title",
        "SEO Description",
        "Google Shopping / Google Product Category",
        "Google Shopping / Gender",
        "Google Shopping / Age Group",
        "Google Shopping / MPN",
        "Google Shopping / AdWords Grouping",
        "Google Shopping / AdWords Labels",
        "Google Shopping / Condition",
        "Google Shopping / Custom Product",
        "Google Shopping / Custom Label 0",
        "Google Shopping / Custom Label 1",
        "Google Shopping / Custom Label 2",
        "Google Shopping / Custom Label 3",
        "Google Shopping / Custom Label 4",
        "Variant Image",
        "Variant Weight Unit",
        "Variant Tax Code",
        "Cost per item",
        "Price / International",
        "Compare At Price / International",
        "Status"
    ];

    public readonly fileName: string;
    private distributor: DistributorDto;
    private itemIdentifier: string;
    private items: DistributorItemDto[] = [];

    constructor(distributor: DistributorDto, itemIdentifier:string) {
        this.distributor = distributor;
        this.itemIdentifier = itemIdentifier;
        this.fileName = `${distributor.code}-${itemIdentifier}.csv`;
    }

    public addItem(item: DistributorItemDto) {
        this.items.push(item);
    }

    public getContents(): string {
        return this.getHeader() + this.getItems();
    }

    private getHeader() {
        return this.headers.join(",") + "\r\n";
    }

    private getItems() {
        let response = "";
        this.items.forEach((item) => {
            response += this.extractItem(item);
        })
        return response;
    }

    private extractItem(item: DistributorItemDto): string {
        let response = "";
        response += item.styleCode + ",";
        response += "?ENTER DESCRIPTION HERE,"
        response += ","
        response += this.distributor.name + ",";
        response += "Apparel & Accessories > Clothing Accessories > Headwear" + ",";
        response += "Cap" + ",";
        response += "?SET TAGS" + ",";
        response += "TRUE" + ",";
        response += "Color" + ",";
        response += this.squeezeString(item.colorCode == null ? "" : item.colorCode).toUpperCase() + ",";
        response += "Size" + ",";
        response += (item.sizeCode == null ? "" : item.sizeCode) + ",";
        response += ",,";
        response += item.suggestedSku + ",";
        response += "?WEIGHT" + ",";
        response += "shopify" + ",";
        response += "0" + ",";
        response += "deny" + ",";
        response += "manual" + ",";
        response += "?PRICE" + ",";
        response += ",";
        response += "TRUE" + ",";
        response += "TRUE" + ",";
        response += ",";
        response += ",";
        response += ",";
        response += "?ALT TEXT" + ",";
        response += ",";
        response += ",";
        response += ",";
        response += ",";
        response += ",";
        response += ",";
        response += ",";
        response += ",";
        response += ",";
        response += "TRUE" + ",";
        response += ",";
        response += ",";
        response += ",";
        response += ",";
        response += ",";
        response += ",";
        response += ",";
        response += ",";
        response += ",";
        response += ",";
        response += ",";
        response += "active" + ",";

        return response + "\r\n";
    }

    private squeezeString(source: string): string {
        let workingString = source.replace(/ \//g, '/');
        return workingString.replace(/\/ /g, '/');
    }


}
